import * as React from 'react';

import { SxProps } from '@mui/system';
import { Card, CardContent, Theme, useTheme } from '@mui/material';

import { DataTableProps } from './data-table';

export const MobileListCard = ({
  children,
  cardSx = {},
  contentSx = {},
}: {
  children: React.ReactNode;
  cardSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
}) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        width: '100%',
        border: '1px inset ' + theme.palette.divider,
        '& .MuiCardContent-root:last-child': {
          padding: '5px !important',
        },
        ...cardSx,
      }}
    >
      <CardContent
        aria-label="unit-detail"
        sx={{
          padding: '10px',
          ...contentSx,
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};

export const MobileListDataTableProps: Partial<DataTableProps> = {
  showCellVerticalBorder: false,
  sx: {
    border: 'none',
    width: '100%',
    '& .MuiDataGrid-root': {
      width: '100%',
    },
    '& .MuiDataGrid-overlayWrapper': {
      width: '100%',
    },
    '& .MuiDataGrid-cell': {
      borderBottom: 'none !important',
      padding: '4px',
      width: '100%',
      '&:focus': {
        outline: 'none',
      },
    },
    '& .MuiDataGrid-columnHeader': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeaders': {
      display: 'none',
    },
    '&:last-child': {
      paddingBottom: '0px',
    },
  },
};
